import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { AUTH_ROUTES, AUTH_STEPS, AUTH_PATHS } from './constants'

/**
 * Hook to manage authentication route state and mapping
 */
export const useAuthRoute = () => {
	const { pathname } = useLocation()
	const [activeStep, setActiveStep] = useState(() => getStepFromPathname(pathname))
	const [activePath, setActivePath] = useState(() => getPathFromPathname(pathname))

	useEffect(() => {
		const step = getStepFromPathname(pathname)
		const path = getPathFromPathname(pathname)
		setActiveStep(step)
		setActivePath(path)
	}, [pathname])

	return { activeStep, activePath, pathname }
}

/**
 * Maps pathname to step index
 */
const getStepFromPathname = (pathname) => {
	switch (pathname) {
		case AUTH_ROUTES.SIGNUP:
			return AUTH_STEPS.SIGNUP
		case AUTH_ROUTES.SIGNUP_OTP:
			return AUTH_STEPS.SIGNUP_OTP
		case AUTH_ROUTES.SIGNIN:
			return AUTH_STEPS.SIGNIN
		case AUTH_ROUTES.SIGNIN_OTP:
			return AUTH_STEPS.SIGNIN_OTP
		case AUTH_ROUTES.FORGET_PASSWORD:
			return AUTH_STEPS.FORGET_PASSWORD
		default:
			return AUTH_STEPS.SIGNUP
	}
}

/**
 * Maps pathname to path string for translations
 */
const getPathFromPathname = (pathname) => {
	switch (pathname) {
		case AUTH_ROUTES.SIGNUP:
			return AUTH_PATHS.signup
		case AUTH_ROUTES.SIGNUP_OTP:
			return AUTH_PATHS['signup-otp']
		case AUTH_ROUTES.SIGNIN:
			return AUTH_PATHS.signin
		case AUTH_ROUTES.SIGNIN_OTP:
			return AUTH_PATHS['signin-otp']
		case AUTH_ROUTES.FORGET_PASSWORD:
			return AUTH_PATHS['forget-password']
		default:
			return ''
	}
}

